import { render, staticRenderFns } from "./SelecaoRecursos.vue?vue&type=template&id=670ab9c2&"
import script from "./SelecaoRecursos.vue?vue&type=script&lang=js&"
export * from "./SelecaoRecursos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports